import { FIN_CHR_MANAGEMENT_ITEM } from './fin-chr-management.js'
import { FIN_CHR_CALENDAR_ITEM } from './fin-chr-calendar.js'
import { FIN_CHR_WALLETS_ITEM } from './fin-chr-wallets.js'

/** @type {import('../help-index.js').HelpScreen} */
export const FIN_CHR_HELP = {
  screenId: 'fin-chr',
  label: 'Cheques Recibidos',
  navPath: 'Finanzas → Cheques Recibidos',
  keywords: [
    'cheque recibido', 'cheque tercero', 'cartera cheques', 'endosar', 'depositar cheque',
  ].map((k) => k.toLowerCase()),
  status: 'draft',
  summary:
    'Gestioná cheques de clientes: se cargan en Cobros, se organizan en carteras y acá depositás, custodiás, rechazás o endosás (este último desde Pagos). Incluye calendario de vencimientos a 30 días.',
  sidebarItems: [FIN_CHR_MANAGEMENT_ITEM, FIN_CHR_CALENDAR_ITEM, FIN_CHR_WALLETS_ITEM],
}
